import { useRef } from 'react'

type TdsModalErrorProps = {
  title: string
  children: React.ReactNode
  handleClose(): void
}

const TdsModalError = ({ title, children, handleClose }: TdsModalErrorProps) => {
  const topRef = useRef<null | HTMLButtonElement>(null)
  const bottomRef = useRef<null | HTMLButtonElement>(null)

  const focusBottom = () => {
    bottomRef?.current?.focus()
  }

  const focusTop = () => {
    topRef?.current?.focus()
  }

  /* eslint-disable jsx-a11y/no-noninteractive-tabindex */
  /* eslint-disable jsx-a11y/no-autofocus */
  return (
    <div
      role="dialog"
      data-backdrop-close="false"
      className="tds-modal tds-modal__dialog--medium"
      id="error-modal"
    >
      <span data-dialog-tab-trap tabIndex={0} onFocus={ focusTop }></span>
      <div
        role="document"
        className="tds-modal__dialog-container"
        aria-labelledby="error-modal-heading-md"
        aria-describedby="error-modal-description-md"
      >
        <div className="tds-modal__dialog-header">
          <h2 className="tds-modal__dialog-title" id="error-modal-heading-md">
            { title }
          </h2>
        </div>
        <div className="tds-modal__dialog-body">
          <div className="tds-modal__dialog-body-content" id="error-modal-description-md">
              { children }
          </div>
        </div>
        <div className="tds-modal__dialog-footer">
          <div className="tds-modal__dialog-button-container">
            <div className="tds-modal__dialog-button-layout">
              <button
                className="tds-button--primary tds-button--small"
                onClick={handleClose}
                data-dismiss="modal"
                ref={ bottomRef }
                autoFocus
              >
                Close
              </button>
            </div>
          </div>
        </div>
        <button
          className="tds-modal__dismiss"
          onClick={handleClose}
          aria-label="Dismiss dialog"
          type="button"
          data-dismiss="modal"
          ref={ topRef }
        >
          <svg focusable="false">
            <use xlinkHref="/claimuploadcenter/icons/symbol-sprites.svg#x-1-12" />
          </svg>
        </button>
      </div>
      <span data-dialog-tab-trap tabIndex={0} onFocus={ focusBottom }></span>
    </div>
  )
}

export { TdsModalError }
